<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{storeName}}培训管理平台</span>
      </div>
    </div>
    <div class="toptitle">
      项目管理
    </div>
    <div class="form">
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="93px"
               label-position="right"
               class="demo-ruleForm">
        <div class="formBox">
          <div class="formLeft">
            <el-form-item label="项目名称："
                          prop="name">
              <el-input v-model="ruleForm.name"
                        placeholder="请输入项目名称"
                        style="width: 329px;"></el-input>
            </el-form-item>
            <el-form-item label="学习日期："
                          prop="startDate">
              <el-date-picker v-model="ruleForm.startDate"
                              type="date"
                              style="width:156px"
                              value-format="yyyy-MM-dd"
                              placeholder="选择开始日期">
              </el-date-picker>
              <div class="timecen"></div>
              <el-date-picker v-model="ruleForm.endDate"
                              type="date"
                              style="width:156px"
                              value-format="yyyy-MM-dd"
                              placeholder="选择结束日期">
              </el-date-picker>
            </el-form-item>
            <span style="font-size:14px;color:#606266">注：课程修改请到课程管理中操作！</span>
          </div>
          <div>
            <el-form-item label="是否为学分项目："
                          label-width="135px"
                          prop="type">
              <el-select v-model="ruleForm.type"
                         style="width: 329px;"
                         placeholder="请选择是否为学分项目">
                <el-option label="是"
                           value="1"></el-option>
                <el-option label="否"
                           value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学分项目内容："
                          v-show="ruleForm.type==1"
                          label-width="135px">
              <el-input type="textarea"
                        class="textarea"
                        style="width: 329px;font-size:14px"
                        placeholder="请输入学分相关信息及获得方式，会以站内信的形式推送给本项目学员"
                        v-model="ruleForm.creditContent"></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <div class="xzbtn"
               style="margin-left:280px"
               @click="submitForm">确认</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'usUpdateProject',
  data () {
    return {
      storeName: '',
      ruleForm: {
        name: '',
        type: '2',
        creditContent: '',
        startDate: '',
        endDate: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: '请选择时间日期', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择是否为学分项目', trigger: 'change' }
        ]
      }
    };
  },
  created () {
    this.storeName = localStorage.getItem('storeName')
    this.getForm()
  },
  methods: {
    getForm () {
      this.httphelper.get('/api/EnterProjectApi/GetOrgprogectById', {
        id: Number(this.$route.query.id)
      })
        .then(res => {
          if (res.code == 200) {
            this.ruleForm.name = res.data.p_Name
            this.ruleForm.type = res.data.isCredit == false ? '2' : '1'
            this.ruleForm.startDate = res.data.startDate
            this.ruleForm.endDate = res.data.endDate
            this.ruleForm.creditContent = res.data.creditContent
          }
        });
    },
    submitForm () {
      if (this.ruleForm.name == '') {
        this.$message.warning('项目名称不能为空');
        return
      } else if (this.ruleForm.type == '') {
        this.$message.warning('请选择是否为学分项目');
        return
      } else if (this.ruleForm.startDate == '' || this.ruleForm.endDate == '') {
        this.$message.warning('学习开始和结束时间均不能为空');
        return
      }
      this.httphelper.post('/api/EnterProjectApi/SaveOrgProject', {
        userId: Number(JSON.parse(localStorage.getItem('ResData')).id),
        id: Number(this.$route.query.id),
        orgId: Number(localStorage.getItem('storeId')),
        orgName: this.ruleForm.name,
        isCredit: this.ruleForm.type == 1 ? true : false,
        startDate: this.ruleForm.startDate,
        endDate: this.ruleForm.endDate,
        creditContent: this.ruleForm.creditContent,
        courIds: ''
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('修改项目成功');
            this.$router.push({
              name: 'usProject'
            })
          } else {
            this.$message.error('修改项目失败');
          }
        });
    }
  }
};
</script>

<style scoped>
.toptitle {
    width: 100%;
    box-sizing: border-box;
    height: 57px;
    background: #f6f7fb;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0b8586;
    line-height: 56px;
    padding-left: 17px;
    margin: 30px 0 40px 0;
}
.formBox {
    display: flex;
    justify-content: space-between;
}
.timecen {
    width: 9px;
    display: inline-block;
    height: 1px;
    background-color: #000000;
    margin: 0px 4px 5px 4px;
}
.xzbtn {
    margin-top: 60px;
    margin-left: 375px;
    width: 200px;
    height: 36px;
    background: #0b8586;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
}
.textarea ::v-deep .el-textarea__inner {
    height: 77px;
    font-family: Microsoft YaHei !important;
}
</style>